module.exports = __webpack_public_path__ + "img/35.84c0a30e.jpg";